import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';

import Axios from '../../services/axios';

export const getOrdersData = createAsyncThunk('getOrders', async (payload, { rejectWithValue }) => {
  try {
    const response = await Axios.post(`/v3/order/list`, payload);
    return response.data;
  } catch (error) {
    toast.error(error?.response?.data?.error || error?.response?.data?.message || 'Error');
    return rejectWithValue(error?.response?.data?.error || 'Error');
  }
});

export const createNewOrder = createAsyncThunk(
  'create_new_order',
  async ({ payload, navigate, getOrdersPayload, creditPayload }, { rejectWithValue }) => {
    try {
      const creditAmount = creditPayload?.patient_credit?.patient_credit_amount || 0
      const response = await Axios.post(`/v3/order/create`, payload);
      if (navigate) {
        navigate('/orders', { state: { prevPayload: getOrdersPayload } });
      }
      toast.success(response?.data?.message);
      if (creditAmount) {
        await Axios.post("/v3/patient/creditBalance/create", creditPayload);
      }
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.response?.data?.error || 'Error');
      return rejectWithValue(error?.response?.data?.error || 'Error');
    }
  }
);

export const createSpecialVisit = createAsyncThunk(
  'create_special_visit',
  async ({ payload, navigate, getOrdersPayload, creditPayload }, { rejectWithValue }) => {
    try {
      const creditAmount = creditPayload?.patient_credit?.patient_credit_amount || 0
      const response = await Axios.post(`/v3/visit/v3/create`, payload);
      if (navigate) {
        navigate('/orders');
      }
      toast.success(response?.data?.message);
      if (creditAmount) {
        await Axios.post("/v3/patient/creditBalance/create", creditPayload);
      }
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.error || error?.response?.data?.message || 'Error');
      return rejectWithValue(error?.response?.data?.error || 'Error');
    }
  }
);

export const handleCancelOrder = createAsyncThunk('cancel_order', async (payload, { rejectWithValue }) => {
  try {
    const response = await Axios.post(`/v3/order/cancel`, payload);
    toast.success(response?.data?.message);
    return response.data;
  } catch (error) {
    toast.error(error?.response?.data?.error || error?.response?.data?.message || 'Error');
    return rejectWithValue(error?.response?.data?.error || 'Error');
  }
});

const initialState = {
  isLoading: false,
  ordersData: null
};

const VisitsSlice = createSlice({
  name: 'orders',
  initialState,
  extraReducers: builder => {
    builder
      .addCase(getOrdersData.pending, state => {
        state.isLoading = true;
      })
      .addCase(getOrdersData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.ordersData = action.payload;
      })
      .addCase(getOrdersData.rejected, state => {
        state.isLoading = false;
        state.ordersData = null;
      });
  }
});

export default VisitsSlice.reducer;
